import { render, staticRenderFns } from "./RechargeComponent.vue?vue&type=template&id=33c35b16&scoped=true"
import script from "./RechargeComponent.vue?vue&type=script&lang=js"
export * from "./RechargeComponent.vue?vue&type=script&lang=js"
import style0 from "./RechargeComponent.vue?vue&type=style&index=0&id=33c35b16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c35b16",
  null
  
)

export default component.exports